module.exports = __webpack_public_path__ + "static/media/edit.f186b653.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Phone/components/PhoneConfirmation/images/edit.svg
// module id = 1289
// module chunks = 0